module.exports = __webpack_public_path__ + "static/MuseoSans-700-6d662ebedd10cd55eca67e6df2ce8d38.woff";